import { Component, Input } from '@angular/core';

@Component({
    selector: 'fcp-floating-button',
    templateUrl: './fcp-floating-button.component.html',
    styleUrls: ['./fcp-floating-button.component.less'],
    standalone: false
})
export class FcpFloatingButtonComponent {
    @Input() iconName: string | string[];
}
